import { colors } from '@pets-ui/tokens/colors.stylex'

export const focusCartListItem = (target: HTMLElement) => {
  target.style.borderColor = colors.grey300
}
